import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 410px;
  height: 70vh;

  display: flex;
  justify-content: center;
  align-items: center;

  h1 {
    text-align: center;
    font-size: 18px;
  }
`;
